define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components", "react-focus-on", "shortid", "../../themes"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _react, _styledComponents, _reactFocusOn, _shortid, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = Dropdown;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  _shortid = _interopRequireDefault(_shortid);
  var _excluded = ["align", "children", "description", "descriptionId", "isCloseButtonHidden", "isDescriptionVisuallyHidden", "isLabelVisuallyHidden", "label", "labelId", "setShowDropdown", "closeTabIndex", "alignAdjustment", "shouldOpenUpwards", "removeArrow", "whiteSpaceNormal"];
  Dropdown.defaultProps = {
    align: 'left',
    description: null,
    descriptionId: _shortid.default.generate(),
    isCloseButtonHidden: false,
    isDescriptionVisuallyHidden: false,
    isLabelVisuallyHidden: false,
    label: null,
    labelId: _shortid.default.generate(),
    closeTabIndex: '0',
    shouldOpenUpwards: false,
    removeArrow: false,
    whiteSpaceNormal: true
  };

  function Dropdown(_ref) {
    var align = _ref.align,
        children = _ref.children,
        description = _ref.description,
        descriptionId = _ref.descriptionId,
        isCloseButtonHidden = _ref.isCloseButtonHidden,
        isDescriptionVisuallyHidden = _ref.isDescriptionVisuallyHidden,
        isLabelVisuallyHidden = _ref.isLabelVisuallyHidden,
        label = _ref.label,
        labelId = _ref.labelId,
        setShowDropdown = _ref.setShowDropdown,
        closeTabIndex = _ref.closeTabIndex,
        alignAdjustment = _ref.alignAdjustment,
        shouldOpenUpwards = _ref.shouldOpenUpwards,
        removeArrow = _ref.removeArrow,
        whiteSpaceNormal = _ref.whiteSpaceNormal,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);

    function handleClose() {
      return setShowDropdown(false);
    }

    return /*#__PURE__*/_react.default.createElement(_reactFocusOn.FocusOn, {
      onClickOutside: handleClose,
      onEscapeKey: handleClose,
      scrollLock: false
    }, /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
      align: align,
      "aria-describedby": descriptionId,
      "aria-labelledby": labelId,
      "aria-modal": "true",
      "data-testid": "dropdown",
      role: "dialog",
      shouldOpenUpwards: shouldOpenUpwards,
      alignAdjustment: alignAdjustment,
      removeArrow: removeArrow,
      whiteSpaceNormal: whiteSpaceNormal
    }, rest), /*#__PURE__*/_react.default.createElement(Header, {
      hideHeader: isCloseButtonHidden && isLabelVisuallyHidden
    }, label && /*#__PURE__*/_react.default.createElement(Label, {
      id: labelId,
      isLabelVisuallyHidden: isLabelVisuallyHidden
    }, label), /*#__PURE__*/_react.default.createElement(FlexSpacing, null), !isCloseButtonHidden && /*#__PURE__*/_react.default.createElement(CloseButton, {
      onClick: handleClose,
      tabIndex: closeTabIndex
    }, /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "#474747"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M19.293 3.293L12 10.586 4.707 3.293 3.293 4.707 10.586 12 3.293 19.293 4.707 20.707 12 13.414 19.293 20.707 20.707 19.293 13.414 12 20.707 4.707z"
    })))), description && /*#__PURE__*/_react.default.createElement(Description, {
      id: descriptionId,
      isDescriptionVisuallyHidden: isDescriptionVisuallyHidden
    }, description), children));
  }

  var Container = _styledComponents.default.div.withConfig({
    displayName: "Dropdown__Container",
    componentId: "sc-1sbnmei-0"
  })(["", " background-color:#fff;border-radius:4px;border:solid 1px ", ";box-shadow:0 1px 2px 0 rgba(0,0,0,0.3);padding:16px;position:absolute;white-space:", ";z-index:30;", " &::before,&::after{border:9px solid transparent;content:'';display:", ";position:absolute;", "}", ""], function (_ref2) {
    var shouldOpenUpwards = _ref2.shouldOpenUpwards;
    return shouldOpenUpwards ? (0, _styledComponents.css)(["bottom:100%;margin-bottom:10px;top:auto;"]) : (0, _styledComponents.css)(["margin-top:10px;"]);
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.gray;
  }, function (_ref4) {
    var whiteSpaceNormal = _ref4.whiteSpaceNormal;
    return whiteSpaceNormal ? 'normal' : 'nowrap';
  }, function (_ref5) {
    var align = _ref5.align;
    return align === 'left' ? (0, _styledComponents.css)(["left:", ";margin-right:16px;"], function (_ref6) {
      var alignAdjustment = _ref6.alignAdjustment;
      return alignAdjustment;
    }) : (0, _styledComponents.css)(["margin-left:16px;right:", ";"], function (_ref7) {
      var alignAdjustment = _ref7.alignAdjustment;
      return alignAdjustment ? alignAdjustment : '2px';
    });
  }, function (_ref8) {
    var removeArrow = _ref8.removeArrow;
    return removeArrow ? 'none' : 'block';
  }, function (_ref9) {
    var align = _ref9.align;
    return align === 'left' ? (0, _styledComponents.css)(["left:16px;"]) : (0, _styledComponents.css)(["right:16px;"]);
  }, function (_ref10) {
    var shouldOpenUpwards = _ref10.shouldOpenUpwards;
    return shouldOpenUpwards ? (0, _styledComponents.css)(["&::before{border-top-color:rgba(0,0,0,0.3);bottom:-19px;}&::after{border-top-color:#fff;bottom:-18px;}"]) : (0, _styledComponents.css)(["&::before{border-bottom-color:rgba(0,0,0,0.3);top:-19px;}&::after{border-bottom-color:#fff;top:-18px;}"]);
  });

  var Header = _styledComponents.default.header.withConfig({
    displayName: "Dropdown__Header",
    componentId: "sc-1sbnmei-1"
  })(["align-items:flex-start;display:flex;flex-direction:row;margin-bottom:16px;", ""], function (_ref11) {
    var hideHeader = _ref11.hideHeader;
    return hideHeader && (0, _styledComponents.css)(["", ";"], _themes.visuallyHidden);
  });

  var Label = _styledComponents.default.h2.withConfig({
    displayName: "Dropdown__Label",
    componentId: "sc-1sbnmei-2"
  })(["color:", ";font-family:", ";font-size:20px;font-weight:600;line-height:24px;margin:0;", ""], function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.dark;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.font.primary;
  }, function (_ref14) {
    var isLabelVisuallyHidden = _ref14.isLabelVisuallyHidden;
    return isLabelVisuallyHidden && (0, _styledComponents.css)(["", ";"], _themes.visuallyHidden);
  });

  var Description = _styledComponents.default.p.withConfig({
    displayName: "Dropdown__Description",
    componentId: "sc-1sbnmei-3"
  })(["color:", ";font-family:", ";font-size:16px;line-height:24px;", ""], function (_ref15) {
    var theme = _ref15.theme;
    return theme.colors.gray;
  }, function (_ref16) {
    var theme = _ref16.theme;
    return theme.font.primary;
  }, function (_ref17) {
    var isDescriptionVisuallyHidden = _ref17.isDescriptionVisuallyHidden;
    return isDescriptionVisuallyHidden && (0, _styledComponents.css)(["", ";"], _themes.visuallyHidden);
  });

  var CloseButton = _styledComponents.default.button.withConfig({
    displayName: "Dropdown__CloseButton",
    componentId: "sc-1sbnmei-4"
  })(["", ";align-items:center;display:flex;justify-content:center;margin-left:8px;margin-top:5px;"], _themes.resetButton);

  var FlexSpacing = _styledComponents.default.div.withConfig({
    displayName: "Dropdown__FlexSpacing",
    componentId: "sc-1sbnmei-5"
  })(["flex:1;"]);
});